module.exports = __webpack_public_path__ + "img/PDAC1_Mono.Macro.8ba34cd2.png";